// Grooming service definitions — single source of truth for values and display labels.
// Keep in sync with backend GroomingBooking.js model enum.
export const GROOMING_SERVICES = [
    { value: 'bath',          label: 'Baño' },
    { value: 'haircut',       label: 'Corte' },
    { value: 'hygiene-cut',   label: 'Corte higiénico' },
    { value: 'deshedding',    label: 'Deslanado' },
    { value: 'medicated-bath', label: 'Baño medicado' },
    { value: 'colorimetry',   label: 'Colorimetría' },
];

// Fast lookup: value → label (e.g. 'bath' → 'Solo baño')
export const GROOMING_SERVICE_LABEL = Object.fromEntries(
    GROOMING_SERVICES.map(s => [s.value, s.label])
);
